export default __webpack_public_path__ + "static/media/christmasGiftDonationEng.1fc4bf18.jpg";